// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cw1H","type":"styles_type__3YsrQ","choices":"styles_choices__2Yp9D"};